<!--
  Main router element for the player.

  @stable
-->

<router-outlet></router-outlet>
